import Layout from '../../hocs/Layout'
import { useParams } from 'react-router'
import { useState } from 'react'
import { connect } from 'react-redux'
import { activate } from '../../redux/actions/auth'
import { Navigate, useNavigate } from "react-router-dom";
import { Circles } from 'react-loader-spinner'
import Button from 'react-bootstrap/Button';

const Activate = ({ activate }) => {
  const params = useParams()
  const navigate = useNavigate();
  const [isActivate, setActivate] = useState(false);
  const [loading, setLoading] = useState(false);

  const activate_account = () => {
    setLoading(true);
    try {
      const uid = params.uid
      const token = params.token
      activate(uid, token);
      setActivate(true);
    } catch (error) { };
    setLoading(false);
  }
  if (isActivate && !loading) {
    navigate("/")
  }

  return (
    <Layout>
      <div className="min-vh-100 d-flex align-items-center bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5 col-lg-4 col-sm-8 col-xs-12">
              <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                <div className="card-header bg-white border-bottom-0 pt-5 pb-0 text-center">
                  <h2 className="text-primary fw-bold mb-0">Activar Cuenta</h2>
                </div>
                <div className="card-body p-5">
                  <p className="text-center text-muted mb-4">
                    Haga clic en el botón a continuación para verificar y activar su cuenta.
                  </p>
                  <div className="d-grid gap-2">
                    {loading ?
                      <Button className="rounded-pill py-2 shadow-sm" disabled>
                        <div className="d-flex justify-content-center">
                          <Circles
                            type="Oval"
                            color="#fff"
                            width={20}
                            height={20}
                          />
                        </div>
                      </Button> :
                      <Button type="submit" onClick={activate_account} className="rounded-pill py-2 fw-bold shadow-sm">
                        Activar Cuenta
                      </Button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default connect(null, {
  activate
})(Activate)